module.exports = __webpack_public_path__ + "static/media/MacPortraitw300@2x.be793cb6.jpg";